import React from "react";
import { Input, Spacer } from '@nextui-org/react';

const CarrierInformation = ({
  setCarrierDetailsToState,
  scacCode,
  dotNumber,
  mcNumber,
  brokerRep,
  isBroker
}) => {
  const inputStyles = {
    css: { 
      $$inputBorderRadius: "0.375rem", 
      flexGrow: 1, 
      h: 40, 
      mt: 2,
      backgroundColor: "white",
      "&:hover": {
        borderColor: "hsl(var(--p))"
      }
    },
    shadow: false,
    bordered: true,
    rounded: true,
    classNames: {
      input: "text-sm",
      label: "text-sm font-medium text-gray-700"
    }
  };

  const labelStyles = "text-sm font-medium text-gray-700 mb-1";
  const gridStyles = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 p-4 bg-base-100 rounded-lg shadow-sm";

  const renderInput = (label, type, placeholder, value, field) => (
    <div className="form-control w-full">
      <label className={labelStyles}>{label}</label>
      <Input
        type={type}
        placeholder={placeholder}
        clearable
        onChange={(e) => setCarrierDetailsToState("carrierDetails", field, e.target.value)}
        value={value}
        {...inputStyles}
      />
    </div>
  );

  const renderCarrierDetails = () => (
    <div className={gridStyles}>
      {renderInput("SCAC Code", "text", "Enter SCAC Code", scacCode, "scacCode")}
      {renderInput("DOT No.", "text", "Enter DOT Number", dotNumber, "dotNumber")}
      {renderInput("MC No.", "text", "Enter MC Number", mcNumber, "mcNumber")}
      {renderInput("Broker Rep", "text", "Enter Broker Rep", brokerRep, "brokerRep")}
    </div>
  );

  return (
    <div className="space-y-4 p-4 bg-base-200 rounded-xl">
      {renderCarrierDetails()}
    </div>
  );
};

export default CarrierInformation;